<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-table :task="getList" :entity="entity" :actions="actions" :filter-entity="filterEntity" />
</template>
<script>
	import { StaticPage, StaticPageFilter } from '@/modules/cms/data/static-page/list'
	import { StaticPageService } from '@/modules/cms/services'
	export default {
		computed:
		{
			entity()
			{
				return StaticPage;
			},
			
			filterEntity()
			{
				return StaticPageFilter;
			},

			service()
			{
				return new StaticPageService();
			},

			actions()
			{
				return [
					{
						routeName: 'cms.staticPage.create',
						resourceKey: 'action.create',
						iconName: 'bi-plus-circle',
						activeMode: 'always',
					},
					{
						routeName: 'cms.staticPage.createImport',
						resourceKey: 'action.import',
						iconName: 'bi-upload',
						activeMode: 'always',
					},
					{
						routeName: 'cms.staticPage.imageAttachment',
						resourceKey: 'action.imageAttachment',
						iconName: 'bi-images',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						routeName: 'cms.staticPage.update',
						resourceKey: 'action.update',
						iconName: 'bi-pen',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						routeName: 'cms.staticPage.delete',
						resourceKey: 'action.delete',
						iconName: 'bi-trash',
						activeMode: 'multiple',
						dataTransferMode: 'store',
					},
					{
						resourceKey: 'action.more',
						iconName: 'bi-arrow-down-short',
						activeMode: 'single',
						children: [{
							routeName: 'cms.staticPage.detail',
							resourceKey: 'cms.staticPageDetail',
							iconName: 'bi-list-columns',
							activeMode: 'single',
							dataTransferMode: 'store',
						}]
					},

				]
			}
		},
		methods:
		{
			async getList(payload)
			{
				return await this.service.list(payload);
			}
		}
	}
</script>